.wrapper {
  display: inline;
  white-space: nowrap;

  span {
    display: inline-block;
    font-weight: bold;
  }

  span:nth-child(1) {
    animation: opacity 1.8s linear 0s infinite;
  }

  span:nth-child(2) {
    margin: 0 1px;
    animation: opacity 1.8s linear 0.25s infinite;
  }

  span:nth-child(3) {
    animation: opacity 1.8s linear 0.5s infinite;
  }
}

@keyframes opacity {

  0%,
  100% {
    opacity: 1;
  }

  40%,
  60% {
    opacity: 0;
  }
}